import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b862658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dept-box" }
const _hoisted_2 = {
  key: 0,
  class: "users"
}
const _hoisted_3 = { class: "users-grid" }
const _hoisted_4 = ["onClick", "title"]
const _hoisted_5 = { class: "username" }

import { reactive, toRefs } from "vue";
import User from "@/mode/User";
import Avatar from "@/components/Avatar.vue";
import showUser from "@/components/user-modal";
import { useRoute } from "vue-router";
import DeptApi from "@/api/DeptApi";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeptInfo',
  setup(__props) {

const route = useRoute();
const data = reactive({
  users: new Array<User>()
});
const deptId = route.params.id;
console.log("deptId", deptId);
if (typeof deptId === "string") {
  DeptApi.users(deptId).then((res) => {
    res.data.forEach((item: User) => {
      data.users.push(item);
    });
  });
}

const { users } = toRefs(data);

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(users).length === 0)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          title: "没有用户哦",
          type: "warning"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_scrollbar, { height: "100%" }, {
      default: _withCtx(() => [
        (_unref(users).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users), (user) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: user.id,
                    class: "user",
                    onClick: ($event: any) => (_unref(showUser)(user.id, true)),
                    title: user.name
                  }, [
                    _createVNode(Avatar, {
                      img: user.avatar,
                      name: user.name
                    }, null, 8, ["img", "name"]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(user.name), 1)
                  ], 8, _hoisted_4))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})